import { breakpoints } from '@etg/wings';
import { css } from '@eti/styles';

const desktopOnlyStyles = css`
  display: none;

  @media (min-width: ${breakpoints._768}) {
    display: block;
  }
`;

interface ZeroWidthSpaceProps {
  isDesktopOnly?: boolean;
  'data-testid'?: string;
}

const ZeroWidthSpace = ({ 'data-testid': dataTestid, isDesktopOnly }: ZeroWidthSpaceProps) => (
  <div className={isDesktopOnly ? desktopOnlyStyles : undefined} data-testid={dataTestid}>
    &#8203;
  </div>
);

export default ZeroWidthSpace;
